import { REQUEST_FEATURES, RECEIVE_FEATURES } from '../constants/actionTypes';
import { FEATURE_LIST } from '../constants/featureFlags';

export const initialState = {
  isFetching: true,
  userConfigFeatures: FEATURE_LIST.reduce(
    (result, feature) => ({
      ...result,
      [feature]: {
        value: false,
      },
    }),
    {}
  ),
};

/**
 * Handles redux state for user config feature flags
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function featureReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_FEATURES:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_FEATURES: {
      const features = action.keys.reduce(
        (_features, key, index) => ({
          ..._features,
          [key]: {
            source: action.values[index]['source-key'],
            value: String(action.values[index].value) === 'true',
          },
        }),
        {}
      );

      return {
        ...state,
        isFetching: false,
        userConfigFeatures: {
          ...state.userConfigFeatures,
          ...features,
        },
      };
    }
    default:
      return state;
  }
}

export default featureReducer;
